// Per-request state, never the mutable Continue cursor or last invocation from
// a previous run. Only pause() publishes; stream termination does not.
export function createDraftPauseTelemetry({ publish, countWords, now = Date.now }) {
  const startedAt = now();
  let invocationId = null;
  let deliveredProse = "";
  let comparison = false;
  let paused = false;
  return {
    receive(chunk) {
      if (chunk.initialInvocationId) invocationId = chunk.initialInvocationId;
      if (chunk.comparisonMode || chunk.benchmarkSessionId) comparison = true;
    },
    deliver(text) {
      deliveredProse += text;
    },
    pause() {
      if (paused) return;
      paused = true;
      const pausedAt = now();
      const prose = deliveredProse.replace(/^\s*#\s*Scene\s+\d+\s*$/gim, "").trim();
      publish({
        invocationId,
        timestamp: new Date(pausedAt).toISOString(),
        elapsedTimeMs: Math.max(0, pausedAt - startedAt),
        // Comparison prose isn't a single delivered manuscript; do not guess.
        deliveredProseWordCount: comparison ? null : prose ? countWords(prose) : 0,
      });
    },
  };
}
